import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { defineComponent, computed, toRefs, ref } from "@vue/composition-api";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { useApplicationStoreGetters } from "../../applications/application/store/application-helpers";
import { capitalize } from "lodash";
import { useI18n } from "vue-i18n-composable";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "SelectLender",
  components: {
    MaterialInput,
    vSelectField
  },
  props: {
    selectedLender: {
      type: [String, Array],
      required: true,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [Object, Array, String],
      default: null
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const {
      handleVSelectMultipleChange
    } = useMultipleSelect();
    const select = ref();
    const {
      selectedLender,
      multiple
    } = toRefs(props);
    const {
      LENDERS
    } = useApplicationStoreGetters([ApplicationGetters.LENDERS]);
    const lenderOptions = computed(() => [{
      value: "all",
      label: capitalize(tc("global.words.all", 1)),
      mtgProductId: "",
      submitCreditReports: true
    }, ...LENDERS.value, {
      label: t("direct-to-lender.lenderSubmit.otherLender"),
      value: "other",
      mtgProductId: "",
      submitCreditReports: true
    }]);
    const localSelectedLender = computed({
      get() {
        var _selectedLender$value;
        return (_selectedLender$value = selectedLender.value) != null ? _selectedLender$value : multiple.value ? [] : "";
      },
      set(newValue) {
        emit("update:selectedLender", newValue);
      }
    });
    const options = computed(() => ({
      placeholder: t("global.actions.chooseOption"),
      closeOnSelect: !multiple.value
    }));
    const handleChange = (selectedValue, type) => {
      var _select$value;
      if (selectedValue.id === "all" && type === "select") (_select$value = select.value) == null ? void 0 : _select$value.close();
      localSelectedLender.value = handleVSelectMultipleChange(selectedValue, type, localSelectedLender.value, multiple.value);
    };
    const formattedLenderOptions = computed(() => {
      var _context;
      return _mapInstanceProperty(_context = lenderOptions.value).call(_context, ref => _objectSpread(_objectSpread({}, ref), {}, {
        id: ref.value,
        text: ref.label
      }));
    });
    return {
      select,
      lenderOptions,
      localSelectedLender,
      options,
      handleChange,
      formattedLenderOptions
    };
  }
});